/* Iter53 P28 — Rework Queue dedicated page.
 *
 * Full-page version of the dashboard rework widget. Shows up to 50 items by default
 * with the same filters + drill-down to SaleDetail.
 *
 * Route: `/rework` (sidebar nav for admin/BO/manager/agent/agentie).
 */
import { useAuth } from "../contexts/AuthContext";
import ReworkQueueWidget from "../components/ReworkQueueWidget";
import { AlertTriangle } from "lucide-react";

export default function ReworkQueuePage() {
  const { user } = useAuth();

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-slate-900 tracking-tight flex items-center gap-2">
          <AlertTriangle className="h-6 w-6 text-amber-600" />
          Coadă Rework
        </h1>
        <p className="text-sm text-slate-500 mt-1">
          Vânzări marcate ca având probleme. Click pe orice rând deschide vânzarea pentru a citi notele și a rezolva problema.
          Rezolvarea se face în interiorul vânzării (banner-ul de rework din Overview).
        </p>
      </div>

      <ReworkQueueWidget user={user} compactLimit={50} />
    </div>
  );
}
